<template>
    <div class="tool-right">
        <div class="right-header">
            <ElButton
                class="!w-[100px] !h-[32px] !p-0 !rounded-[10px] !text-sm !text-white !bg-[#4C5BDF]"
                color="#ffffff"
                :disabled="loading || !currentScenes"
                @click="clipboardClick"
                >复制文本</ElButton
            >
        </div>

        <div class="right-cont">
            <div v-if="!currentScenes" class="text-sm text-[#dddddd] text-center">
                暂无内容
            </div>
            <div v-else-if="currentScenes?.state === 'error'" class="text-sm text-[#dddddd] text-center">
                抱歉加载失败，请重试
            </div>
            <template v-else>
                <div v-if="currentScenes.title" class="cont-title">
                题目: {{ currentScenes.title }}
                </div>
                <div class="markdown-body text-[15px] font-normal" v-html="answer"></div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props:['loading','currentScenes'],
    data() {
        return {
            
        }
    },
    methods: {
        clipboardClick(){
            
        }
    }
}
</script>

<style lang="scss">
.tool-right{
    @apply p-8;
    .right-header{
        @apply flex items-center justify-end mb-5;
    }
    .right-cont{
        @apply w-full h-full p-4 bg-white rounded-[15px] border border-dashed border-[#C2C4CB] overflow-hidden;
        .cont-title{
            @apply  mb-5 text-sm text-[#4C5BDF] line-clamp-2;
        }
        .markdown-body{
            @apply text-sm text-justify text-[#444444];
        }
    }
}
</style>